/**
 * Возвращает набор цветов для графиков в зависимости от индекса графика,
 * чтобы обеспечить согласованные, но разнообразные цветовые схемы
 */
export const getChartColors = (chartIndex) => {
    const colorSets = [
      // Цвета для графика проектов
      ['#0f766e', '#3b82f6', '#0ea5e9', '#14b8a6'],
      // Цвета для графика инженеров
      ['#0e9488', '#0ea5e9', '#0f766e', '#0d9488'],
      // Цвета для графика стадий
      ['#0f766e', '#14b8a6', '#0ea5e9', '#3b82f6', '#22d3ee', '#0d9488'],
    ];
  
    // Возвращаем набор цветов для указанного графика или первый набор по умолчанию
    return colorSets[chartIndex] || colorSets[0];
  };